/** 券详情弹窗的按钮状态 */
export enum ExchButtonStatus {
  /** 立即领取 */
  ToReceive = 1,
  /** 待解锁 */
  IsLocked,
  /** 去使用 */
  ToUse,
  /** 隐藏 */
  Hidden,
  /** 库存限制 */
  IsLimit
}
